import React, { useEffect, useState } from "react";
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  CloseButton,
  Flex,
  FormControl,
  FormLabel,
  Spinner,
  Stack,
  Switch,
  Text,
} from "@chakra-ui/react";
import AppShell from "./AppShell";
import useTodosData from "../hooks/useTodosData";
import SimpleTaskList from "./tasks/SimpleTaskList";
import DetailedTaskList from "./tasks/DetailedTaskList";
import CalendarView from "./tasks/CalendarView";
import AddTodo from "./tasks/AddTodo";
import ApiTokens from "./ApiTokens";

const TOKEN_GUIDE_KEY = "worryless_show_token_guide";

export default function Todos({ user_id }) {
  const [tab, setTab] = useState("list");
  const [detailed, setDetailed] = useState(false);
  const [showTokenGuide, setShowTokenGuide] = useState(false);
  const { todos, nextPlan, loading, error, refresh, completeTodo } = useTodosData(user_id);

  useEffect(() => {
    try {
      if (localStorage.getItem(TOKEN_GUIDE_KEY) === "1") {
        setShowTokenGuide(true);
      }
    } catch {
      // ignore
    }
  }, []);

  const dismissTokenGuide = () => {
    setShowTokenGuide(false);
    try {
      localStorage.removeItem(TOKEN_GUIDE_KEY);
    } catch {
      // ignore
    }
  };

  return (
    <AppShell tab={tab} onTabChange={setTab}>
      <Stack spacing={4} w="100%" align="stretch">
        {showTokenGuide ? (
          <Alert status="info" borderRadius="md" alignItems="flex-start">
            <AlertIcon mt={1} />
            <Box flex="1">
              <AlertTitle fontSize="sm">Connect your Grok Bot</AlertTitle>
              <AlertDescription fontSize="sm">
                Open <strong>Settings</strong>, create an API token named <strong>Grok Bot</strong>, and paste it into
                your Grok Bot when it asks for WorryLess access.
              </AlertDescription>
            </Box>
            <CloseButton alignSelf="flex-start" onClick={dismissTokenGuide} />
          </Alert>
        ) : null}
        <Flex justify="space-between" align="center" gap={3} flexWrap="wrap">
          <AddTodo user_id={user_id} onAdded={refresh} />
          {tab === "list" ? (
            <FormControl display="flex" alignItems="center" w="auto">
              <FormLabel htmlFor="detailed-view" mb={0} fontSize="sm" color="gray.600">
                Detailed view
              </FormLabel>
              <Switch
                id="detailed-view"
                size="sm"
                isChecked={detailed}
                onChange={(event) => setDetailed(event.target.checked)}
              />
            </FormControl>
          ) : null}
        </Flex>

        {loading ? (
          <Flex justify="center" py={10}>
            <Spinner />
          </Flex>
        ) : null}

        {error && tab !== "settings" ? (
          <Alert status="error" borderRadius="md">
            <AlertIcon />
            {error}
          </Alert>
        ) : null}

        {!loading && tab === "settings" ? (
          <ApiTokens />
        ) : !loading && !error ? (
          tab === "calendar" ? (
            <CalendarView todos={todos} />
          ) : detailed ? (
            <DetailedTaskList user_id={user_id} todos={todos} refresh={refresh} />
          ) : (
            <SimpleTaskList todos={todos} nextPlan={nextPlan} onDone={completeTodo} />
          )
        ) : null}

        {!loading && !error && tab === "list" && !detailed ? (
          <Text fontSize="xs" color="gray.500" textAlign="center">
            Tasks refresh every minute. Turn on Detailed view to edit rank, precedence, and raw fields.
          </Text>
        ) : null}
      </Stack>
    </AppShell>
  );
}
